import React from 'react';
import PropTypes from 'prop-types';
import styles from './SplitContentContainer.module.css';

function SplitContentContainer({ leftColumnContent, rightColumnContent, borderPosition, stackedVersion }) {
  let borderPositionClass = 'center';
  if (borderPosition === 'left') {
    borderPositionClass = styles.borderPositionLeft;
  } else if (borderPosition === 'right') {
    borderPositionClass = styles.borderPositionRight;
  }

  if (!leftColumnContent && !rightColumnContent) {
    return null;
  } else if (!leftColumnContent && rightColumnContent) {
    return (
      <div className={`${styles.container} ${styles.fullWidth} ${stackedVersion ? styles.fixedHeight : ''}`}>
        {rightColumnContent}
      </div>
    );
  } else if (leftColumnContent && !rightColumnContent) {
    return (
      <div className={`${styles.container} ${styles.fullWidth} ${stackedVersion ? styles.fixedHeight : ''}`}>
        {leftColumnContent}
      </div>
    );
  }

  return (
    <div className={`${styles.container} ${stackedVersion ? styles.containerStacked : ''}`}>
      <div className={`${styles.leftWidget} ${borderPositionClass}`}>
        {leftColumnContent}
      </div>
      <div className={`${styles.rightWidget} ${borderPositionClass}`}>
        {rightColumnContent}
      </div>
    </div>
  );
}

SplitContentContainer.propTypes = {
  leftColumnContent: PropTypes.object,
  rightColumnContent: PropTypes.object,
  borderPosition: PropTypes.string,
  stackedVersion: PropTypes.bool,
};

export default SplitContentContainer;

